import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance monitoring - sample 100% of transactions in production
  // Adjust this value once you have sufficient traffic
  tracesSampleRate: 1.0,
  // Session Replay - capture 10% of sessions, 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Only send events when DSN is configured
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});
